export const GET_SUPPLIERS = "GET_SUPPLIERS"
export const GET_SUPPLIERS_SUCCESS = "GET_SUPPLIERS_SUCCESS"
export const GET_SUPPLIERS_FAIL = "GET_SUPPLIERS_FAIL"

export const ADD_NEW_SUPPLIER = "ADD_NEW_SUPPLIER"
export const ADD_NEW_SUPPLIER_SUCCESS = "ADD_NEW_SUPPLIER_SUCCESS"
export const ADD_NEW_SUPPLIER_FAIL = "ADD_NEW_SUPPLIER_FAIL"

export const UPDATE_SUPPLIER = "UPDATE_SUPPLIER"
export const UPDATE_SUPPLIER_SUCCESS = "UPDATE_SUPPLIER_SUCCESS"
export const UPDATE_SUPPLIER_FAIL = "UPDATE_SUPPLIER_FAIL"

export const DELETE_SUPPLIER = "DELETE_SUPPLIER"
export const DELETE_SUPPLIER_SUCCESS = "DELETE_SUPPLIER_SUCCESS"
export const DELETE_SUPPLIER_FAIL = "DELETE_SUPPLIER_FAIL"

export const GET_SUPPLIER_INVOICES = "GET_SUPPLIER_INVOICES"
export const GET_SUPPLIER_INVOICES_SUCCESS = "GET_SUPPLIER_INVOICES_SUCCESS"
export const GET_SUPPLIER_INVOICES_FAIL = "GET_SUPPLIER_INVOICES_FAIL"

export const ADD_NEW_SUPPLIER_INVOICE = "ADD_NEW_SUPPLIER_INVOICE"
export const ADD_NEW_SUPPLIER_INVOICE_SUCCESS = "ADD_NEW_SUPPLIER_INVOICE_SUCCESS"
export const ADD_NEW_SUPPLIER_INVOICE_FAIL = "ADD_NEW_SUPPLIER_INVOICE_FAIL"
